import CalculatorStandardInput from '../../../../calculatorInputs/CalculatorStandardInput';
import i18next from 'i18next';
import {
  AttributeType,
  REGEXP_DECIMAL,
  REGEXP_INTEGER,
  REGEXP_PERCENTAGE,
} from '../../../../../../../../services/common/Constants';
import React from 'react';

const ComparisonValue = ({ fieldName, showLabel, availableValueOptions,selectedFieldSubType, readOnly = false }) => {
  return (
    <CalculatorStandardInput
      fieldName={`${fieldName}.${0}`}
      label={`${
        showLabel ? i18next.t('calculator.dialog.create.label.values') : ''
      }`}
      placeholder={i18next.t(
        `calculator.dialog.create.placeholder.selectValues`
      )}
      options={availableValueOptions}
      uxVariant="criteriaInput"
      variant="standard"
      isRequired
      triggerOnContinue
      validate={(value) => {
        switch (selectedFieldSubType) {
          case AttributeType.INTEGER:
            return value && !value.match(REGEXP_INTEGER)
              ? i18next.t('attributes.errors.integer')
              : null;
          case AttributeType.DECIMAL:
            return value && !value.match(REGEXP_DECIMAL)
              ? i18next.t('attributes.errors.decimal')
              : null;
          case AttributeType.PERCENTAGE:
            return value && !value.match(REGEXP_PERCENTAGE)
              ? i18next.t('attributes.errors.percentage')
              : null;
          default:
            return null;
        }
      }}
      disabled={readOnly}
    />
  );
};

export default ComparisonValue;
